import { BasicButton } from "@goodgamestudios/asset-globals";

import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicScreen } from "@goodgamestudios/core";
import { BasicToolTipManager } from "@goodgamestudios/core";

import { TextField } from "@goodgamestudios/createjs-utilities";
import { TextFieldType } from "@goodgamestudios/createjs-utilities";

import { BasicTutorialController } from "../../../basic/controller/BasicTutorialController";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2PanelEvent } from "../../event/Poker2PanelEvent";
import { Poker2TutorialEvent } from "../../event/Poker2TutorialEvent";

import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;
import Container = createjs.Container;

export class Poker2Screen extends BasicScreen {
    constructor(disp: DisplayObject) {
        super(disp);
        disp.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        disp.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        this.controller.addEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));

        (this.disp as Container).changeTextFieldCacheScale(2);
    }
    public destroy(): void {
        super.destroy();
        this.disp.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOver));
        this.disp.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOut));
        this.controller.removeEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
    protected get controller(): BasicController {
        return BasicController.getInstance();
    }
    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton) {
            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);
        }
    }

    protected updateTextField(textField: TextField): void {
        Poker2LanguageFontManager.getInstance().changeFontByLanguage(textField);
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = this.layoutManager.scaleFactor;
            this.disp.x = (this.disp.stage.stageWidth / 2) - (800 / 2) * this.disp.scaleX;
        }
    }

    protected onMouseOver(event: MouseEvent): void {
        this.controller.dispatchEvent(new Poker2PanelEvent("mouseonpanel"));
        super.onMouseOver(event);
        if (BasicToolTipManager.TOOLTIP_LABEL in event.target) {
            this.layoutManager.tooltipManager.show(event.target.toolTipText, event.target as DisplayObject);
        }
    }

    protected onMouseOut(event: MouseEvent): void {
        super.onMouseOut(event);
        if (BasicToolTipManager.TOOLTIP_LABEL in event.target)
            this.layoutManager.tooltipManager.hide();
    }

    protected onCursorOver(event: MouseEvent): void {
        if (event.target instanceof BasicButton)
            if ((event.target as BasicButton).enabled)
                this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);

        if (event.target instanceof TextField)
            if ((event.target as TextField).type == TextFieldType.INPUT)
                this.layoutManager.customCursor.isEnabled = false;
    }

    protected onCursorOut(event: MouseEvent): void {
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
        if (event.target instanceof TextField)
            if ((event.target as TextField).type == TextFieldType.INPUT)
                this.layoutManager.customCursor.isEnabled = true;
    }

    protected onTutorialEvent(event: Poker2TutorialEvent): void {
        switch (Poker2TutorialController.getInstance().tutorialState) {
            case BasicTutorialController.TUT_STATE_COMPLETED:
                this.controller.removeEventListener("tutorialstatechange", this.bindFunction(this.onTutorialEvent));
                break;
        }
    }

}
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2LanguageFontManager } from "../Poker2LanguageFontManager";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
